import { Link } from 'react-router-dom';
import { NAV_ITEMS } from '@/mocks';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-700">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <span className="text-2xl font-heading font-bold text-primary-500 tracking-tight">777</span>
              <span className="text-lg font-heading font-semibold text-foreground-100">影院</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              777影院午夜伦不卡提供电影、电视剧、综艺等在线观看，高清画质，流畅不缓冲，免费看全集，极速播放体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {NAV_ITEMS.slice(0, 4).map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/dianying" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">热门电影</Link></li>
              <li><Link to="/category/dianshiju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">热播电视剧</Link></li>
              <li><Link to="/category/zongyi" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">热门综艺</Link></li>
              <li><Link to="/category/dongman" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">热门动漫</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">品牌介绍</Link></li>
              <li><span className="text-sm text-foreground-500">客服邮箱：service@777cinema.com</span></li>
              <li><span className="text-sm text-foreground-500">服务时间：9:00-24:00</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 777影院 版权所有 | 777影院午夜伦不卡
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}